module.exports = __webpack_public_path__ + "static/media/vw-logo.57d775c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/imgs/vw-logo.svg
// module id = 901
// module chunks = 0